<template>
    <div class="OpenCard">
        <div class="OpenCard_header">
            <div class="OpenCard_header_title">
                <p>开卡</p>
            </div>
            <StepsData :active="active" />
        </div>

        <div class="one" v-if="active == 0">
            <div class="one_header">
                <div class="one_header_tit">
                    <div class="tu">
                        <img src="~@/assets/images/opencard/open1.png" alt="" />
                    </div>
                    <div>填写开卡信息</div>
                </div>
                <div class="stepNumber">1/4</div>
            </div>
            <TypeNumber :condition="condition" :Iphone="Iphone" ref="openCardForm" :wholetcard="wholetcard"
                :sparePhone="sparePhone" @form-change="onFormChange" />
            <IpLocation ref="ipLocation" />
        </div>

        <div class="two" v-if="active == 1">
            <div class="one_header">
                <div class="one_header_tit">
                    <div class="tu">
                        <img src="~@/assets/images/opencard/open3.png" alt="" />
                    </div>
                    <div>默认套餐</div>
                </div>
                <div class="stepNumber">2/4</div>
            </div>
            <div class="one_content">
                <div class="setMeas">
                    <div class="setMea">
                        <div class="setMea_title">
                            <div class="setMea_name">
                                {{ prodOfferName }}
                            </div>
                            <div class="setMea_price">￥{{ sumFee }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="three" v-if="active == 2">
            <div class="one_header">
                <div class="one_header_tit">
                    <div class="tu">
                        <img src="~@/assets/images/opencard/open4.png" alt="" />
                    </div>
                    <span>入网协议</span>
                </div>
                <div class="yenum">3/4</div>
            </div>
            <Four @imgBase64Data="onSignChange" @checked-change="onCheckedChange" @read_all="handleReadAll" />
        </div>

        <!-- 拍照开始 -->
        <div v-if="active == 3">
            <Three class="five" @ImgsBase64Data="ImgsBase64"></Three>
        </div>
        <!-- 拍照结束 -->

        <div class="four" v-if="active == 4">
            <div class="one_header">
                <div class="one_header_tit">
                    <div class="tu">
                        <img src="~@/assets/images/opencard/open2.png" alt="" />
                    </div>
                    <div>实名认证</div>
                </div>
                <div class="stepNumber">3/4</div>
            </div>
            <!-- v-if="ifCheckCard == '0'" -->
            <div class="three_goautonym" @click="goautonym">
                <img src="~@/assets/images/opencard/open5.png" alt="" />
            </div>
        </div>

        <div class="OpenCard_footer">
            <button @click="NextStep">
                {{ active == 4 ? "去实名" : "下一步" }}
            </button>
        </div>
    </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import preventBack from "vue-prevent-browser-back"
import Four from "../../components/openCard/four.vue"
import Three from "../../components/openCard/three.vue"
import IpLocation from "../../components/IpLocation.vue"
import TypeNumber from "../../components/openCard/TypeNumber.vue"
import StepsData from "../../components/openCard/openCardSteps.vue"
import OpenCardParamsMixin from '../../components/openCard/OpenCardParamsMixin.js';
import {
    SimOrServiceIdQuery,
    CheckIccid,
    QueryOpenCardLocation,
    CheckPhoneValid,
    ChanelCheck,
    AppCommonCheck,
    Checkoffername,
    AddOpenCardLocation,
    SignatureUpload,
    GetUrl,
    GetSimpleOrCardNum,
    DoCheckIdentityCodeByWorkNo,
    QuerySign,
    Dosubmits,
    UploadCard,
} from "../../common/newapi/api.js"
export default {
    components: {
        Four, Three, StepsData, IpLocation, TypeNumber
    },
    mixins: [preventBack, OpenCardParamsMixin], //注入  阻止返回上一页
    data() {
        return {
            active: "0", //流程进度
            condition: 1, //填写开卡信息输入框是否为可编辑状态 1为可编辑 2为不可编辑
            Iphone: "", //用户输入的手机号
            wholetcard: "", //用户输入的的后七位iccid号码
            sparePhone: "", //用户输入的联系方式
            // 生产环境
            FullCard: "", //完整的卡号
            prodOfferName: "", //套餐名称
            sumFee: "", //套餐价格
            judge: false, //实名认证完成返回页面的变量
            //入网协议数据
            imgsData: "", //电子签名照片数据
            isReadAll: false, //入网协议是否已读
            CheckedState: false, //入网协议选中状态
            sign: "", //提交加密接口的加密串
            timestamp: "", //提交加密接口的时间戳
            payNum: false, //支付查询的开关 000开始查询
            // 是否增加小卡版数据
            TogetherImgsData: "", //合拍base64码
            ifCheckCard: "", //实名认证背景图是否添加小卡版显示隐藏

            // 接口数据
            SimOrServiceIdQueryDatas: {}, //号卡查询接口的数据
            checkphonevaliddata: {}, //号卡有效性验证的数据
            ProdOfferData: {}, //获取的默认套餐页面数据
            QueryOne: {}, //第一次查询开卡记录的数据
            // 接口数据结束

            // 业务类型为4的小号、云语套餐
            // 1354022:蓝猫基础卡套餐、1354242: 蓝猫企信通套餐
            // 1354364:蓝猫云语套餐、1354455: 蓝猫云通信套餐(联通)
            // 1354602: 蓝猫云通信A套餐（联通）、
            systemIdFour: ["1354022", "1354242", "1354364", "1354455", "1354602"],
            // 业务类型为7的短信套餐
            // 1354122:蓝猫副号A套餐、1354262: 蓝猫副号C套餐、1354283: 蓝猫副号D套餐、
            systemIdSeven: ["1354122", "1354262", "1354283", "1354882"],
            cityCode: "", //城市信息
        }
    },

    created() {
        this.authentication()
        this.wxPayQuery()
    },
    // 组件方法
    methods: {
        // 获取用户输入信息
        onFormChange(form) {
            this.Iphone = form.Iphone
            this.wholetcard = form.wholetcard
            this.sparePhone = form.sparePhone
        },

        async NextStep() {
            // 第一页
            if (this.active == 0) {
                const verifyResult = this.$refs.openCardForm.validateForm()
                if (!verifyResult.valid) {
                    this.showToast(verifyResult.message);
                    return;
                } else {
                    // 获取IP信息
                    try {
                        const ip = await this.$refs.ipLocation.fetchLocation();
                        console.log("从 IpLocation 获取的 IP 地址:", ip);
                        this.cityCode = ip; // 将获取的城市信息赋值给 cityCode
                    } catch (error) {
                        console.error("获取 IP 地址失败:", error);
                        this.cityCode = "360"; // 默认值
                    }

                    // 号码查询
                    try {
                        var SimOrServiceIdQueryData = await SimOrServiceIdQuery({
                            iccidOrServiceId: this.Iphone,
                            sparePhone: this.sparePhone, //用户输入的联系方式
                            type: 2,
                        })
                    } catch (err) {
                        this.showToast("号码查询失败");
                    }
                    //将号卡查询接口的数据保存
                    if (SimOrServiceIdQueryData.code != "0000") {
                        this.showToast(SimOrServiceIdQueryData.msg);
                    } else {
                        this.SimOrServiceIdQueryDatas = SimOrServiceIdQueryData
                        localStorage.setItem("uimId", SimOrServiceIdQueryData.cardNo)   //将卡号添加至本地缓存
                        this.FullCard = SimOrServiceIdQueryData.cardNo  //获取完整卡号
                        //首次查询开卡记录(判断首次有没有开卡流程)
                        var QueryOpenCardData = await QueryOpenCardLocation({
                            uimId: this.FullCard,
                        })
                        this.QueryOne = QueryOpenCardData.data
                        console.log('this.QueryOnethis.QueryOne', this.QueryOne)
                        // 有开卡进程
                        if (QueryOpenCardData.code == 1) {
                            if (QueryOpenCardData.data.openCardLocation == 1) {
                                // 套餐名称及价格赋值渲染
                                this.prodOfferName = QueryOpenCardData.data.prodOfferName
                                this.sumFee = QueryOpenCardData.data.sumFee

                                // 通过判断rechargeAmount(充值金额)跟rechargeFlag[(支付标记)start为没有充值，finish为已充值成功]
                                // 充值金额大于0 与 支付标记为finish时为充值成功
                                const { sumFee, rechargeFlag, openCardLocation } = QueryOpenCardData.data;
                                if (sumFee > 0) {
                                    if (rechargeFlag === "start") {
                                        // 有充值但未支付成功，跳转支付页
                                        this.$router.push("/OpenPay");
                                        return;
                                    }
                                    // 已充值成功，跳转到对应步骤
                                    this.active = openCardLocation;
                                } else {
                                    // 套餐价格为0，直接跳转到入网协议
                                    this.active = 2;
                                }
                            }
                            // 判断等于2
                            else if (QueryOpenCardData.data.openCardLocation == 2) {
                                // 通过判断 rechargeFlag、rechargeAmount、tradeNo、outTradeNo、来判断是否有充值
                                this.ifCheckCard = this.QueryOne.ifCheckCard //是否显示小卡版赋值
                                this.active = QueryOpenCardData.data.openCardLocation //跳转相应页面
                            }
                            // openCardLocation等于3，之前跳转签名页
                            else if (QueryOpenCardData.data.openCardLocation == 3) {
                                this.ifCheckCard = this.QueryOne.ifCheckCard //是否显示小卡版赋值
                                this.active = QueryOpenCardData.data.openCardLocation // 直接跳转到存储的页面中
                            } else if (QueryOpenCardData.data.openCardLocation == 4) {
                                this.ifCheckCard = this.QueryOne.ifCheckCard //是否显示小卡版赋值
                                this.active = QueryOpenCardData.data.openCardLocation // 直接跳转到存储的页面中
                            } else {
                                console.log("开卡流程缺失")
                            }
                        }
                        // 没有开过卡就正常流程
                        else {
                            let Userdata = JSON.parse(
                                localStorage.getItem("Userdata")
                            )
                            // 卡号后七位校验
                            let CheckIccidData = await CheckIccid({
                                serviceId: this.Iphone,
                                iccid: this.wholetcard,
                            })

                            if (CheckIccidData.code != 1) {
                                this.showToast(CheckIccidData.msg);
                            } else {
                                //号卡有效性验证接口
                                var CheckPhoneValidData = await CheckPhoneValid(
                                    {
                                        serviceId: this.Iphone, //用户输入的手机号
                                        uimId: this.FullCard, //用户输入的iccid
                                        workNo: Userdata.workNo,
                                        appType: Userdata.dealerName,
                                    }
                                )

                                if (CheckPhoneValidData.code != 0) {
                                    this.showToast(CheckPhoneValidData.msg);
                                }
                                // 号卡有效性验证否则(接口成功)
                                else {
                                    this.checkphonevaliddata = CheckPhoneValidData.data
                                    //渠道校验接口
                                    var ChanelCheckData = await ChanelCheck({
                                        serviceId: this.Iphone, //用户输入的手机号
                                        workNo: localStorage.getItem("workNo"),
                                    })

                                    if (ChanelCheckData.code != 0) {
                                        this.showToast(ChanelCheckData.msg);
                                    }
                                    //渠道校验否则(接口成功)
                                    else {
                                        //激活期和冻结接口
                                        var AppCommonCheckData = await AppCommonCheck({
                                            serviceId: this.Iphone, //用户输入的手机号
                                            workNo: localStorage.getItem("workNo"),
                                        })

                                        if (AppCommonCheckData.code != 0) {
                                            this.showToast(AppCommonCheckData.msg);
                                        }
                                        //激活期和冻结否则(接口成功)
                                        else {
                                            //未激活号码套餐展示
                                            var CheckoffernameData = await Checkoffername({
                                                WorkNo: localStorage.getItem("workNo"),
                                                serviceId: this.Iphone, //用户输入的手机号
                                                iccId: this.FullCard, //用户输入的iccid
                                                type: 2, //查询类型
                                                SystemId: 1, //来源类型
                                            })
                                            if (CheckoffernameData.code != 1) {
                                                this.showToast(CheckoffernameData.msg);
                                            }
                                            //未激活号码套餐展示否则
                                            else {
                                                // 将获取的套餐数据渲染至页面
                                                this.ProdOfferData = CheckoffernameData.data
                                                // 套餐名称及价格赋值渲染
                                                this.prodOfferName = CheckoffernameData.data.prodOfferName
                                                this.sumFee = CheckoffernameData.data.sumFee

                                                // 获取本地修改的业务类型
                                                let systemId = localStorage.getItem("systemId")

                                                // 短信套餐：default_sale_kind为4，system_id转换为7，符合开卡条件
                                                if (systemId == "7") {
                                                    // 套餐ID为短信套餐时,套餐ID为1354122,符合开卡条件
                                                    if (this.systemIdSeven.find(item => item == CheckoffernameData.data.prodOfferId)) {
                                                        this.active = 1
                                                    } else {
                                                        this.showToast("此号码套餐异常，请在蓝猫云商APP开卡激活");
                                                    }
                                                }
                                                //"小号业务"及 "云语套餐" default_sale_kind为3，system_id转换为4
                                                else if (systemId == "4") {
                                                    if (this.systemIdFour.find(item => item == CheckoffernameData.data.prodOfferId)) {
                                                        this.active = 1
                                                    } else {
                                                        this.showToast("此号码套餐异常，请在蓝猫云商APP开卡激活");
                                                    }
                                                } else {
                                                    this.showToast("此号码请在蓝猫云商APP开卡激活");
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } // 第二页
            else if (this.active == 1) {
                let Userdata = JSON.parse(localStorage.getItem("Userdata"))
                let AddOpenCardOnePay = await AddOpenCardLocation({
                    applyEvent: "1", //业务类型
                    belongCode: "360", //号码归属地
                    cityCode: this.cityCode, //受理人所在地市
                    dealerId: Userdata.dealerId, //代理商编号
                    dealerMainId: Userdata.dealerMainId, //顶级渠道
                    uimId: this.checkphonevaliddata.uimId, //卡号
                    acceptPerson: this.ProdOfferData.workNo, //工号
                    ifCheckCard: this.ProdOfferData.ifCheckCard, //是否添加小卡版
                    serviceId: this.SimOrServiceIdQueryDatas.phoneNum, //手机号
                    resInstId: this.checkphonevaliddata.serviceInstId, //号码的实例ID
                    serviceKind: this.checkphonevaliddata.serviceKind, //运营商类型
                    uimResInstId: this.checkphonevaliddata.uimInstId, //卡号的实例ID
                    prodOfferId: this.SimOrServiceIdQueryDatas.prodOfferId, //套餐ID
                    recordNumber: this.SimOrServiceIdQueryDatas.recordNumber, //订单号

                    // 第一次添加redis不同参数
                    rechargeFlag: this.ProdOfferData.sumFee > 0 ? "start" : "nopay", //充值标记 start进入支付 nopay未支付
                    prodOfferName: this.ProdOfferData.prodOfferName, //套餐名称
                    openCardLocation: this.ProdOfferData.sumFee > 0 ? "1" : "2", //步骤条进度
                    sumFee: this.ProdOfferData.sumFee > 0 ? this.ProdOfferData.sumFee : "", //充值金额
                    PayBackUrl: "/OpenCard", //支付返回地址
                })
                if (AddOpenCardOnePay.code != 1) {
                    Dialog.alert({
                        message: "缓存记录失败,请重新进行开卡",
                    }).then(() => {
                        this.active = 0
                    })
                } else {
                    if (this.ProdOfferData.sumFee > 0) {
                        // 价格大于0跳转支付页面
                        localStorage.setItem("PayBackUrl", "/OpenCard")
                        this.$router.push("/OpenPay")
                    } else {
                        // 价格等于0跳转到入网协议页面
                        this.active = 2
                    }
                }
            }
            // 第三页
            else if (this.active == 2) {
                if (!this.isReadAll) {
                    this.showToast("请完整看完《蓝猫移动入网协议》");
                } else if (this.CheckedState == false) {
                    this.showToast("请您阅读并同意《蓝猫移动入网协议》");
                } else if (this.imgsData == "") {
                    this.showToast("电子签名不能为空");
                } else {
                    //上传签名查询开卡记录
                    let QueryOpenCardLocationData = await QueryOpenCardLocation(
                        {
                            uimId: localStorage.getItem("uimId"),
                        }
                    )
                    if (QueryOpenCardLocationData.code != 1) {
                        Dialog.alert({
                            message: "开卡时间过长数据缺失,请重新输入手机号",
                        }).then(() => {
                            this.active = 0
                        })
                    } else {
                        // 上传签名接口
                        let SignatureUploadData = await UploadCard({
                            image: this.imgsData, //签名图片路径
                        })

                        if (SignatureUploadData.code != 1) {
                            this.showToast(SignatureUploadData.msg);
                        }
                        //上传签名否则(接口成功)
                        else {
                            let CheckCard = QueryOpenCardLocationData.data.ifCheckCard
                            let params = this.getOpenCardLocationParams(QueryOpenCardLocationData.data);
                            // 4、签名后增加缓存记录（入网协议增加缓存记录）
                            var AddOpenCardLocationTwo = await AddOpenCardLocation({
                                ...params,
                                netSignUrl: SignatureUploadData.data, //签名图片地址
                                openCardLocation: CheckCard == 0 ? "4" : "3", //步骤条进度
                            })
                            if (AddOpenCardLocationTwo.code != 1) {
                                Dialog.alert({
                                    message: "缓存记录失败,请重新进行开卡",
                                }).then(() => {
                                    this.active = 0
                                })
                            } else {
                                this.ifCheckCard = QueryOpenCardLocationData.data.ifCheckCard
                                // 是否添加小卡板为0时，不用合拍跳转实名；1：需要合拍跳转合拍页
                                this.ifCheckCard != 1 ? this.active = 4 : this.active = 3
                            }
                        }
                    }
                }
            }
            // 第四页 合拍页
            else if (this.active == 3) {
                if (this.TogetherImgsData == "") {
                    this.showToast("请点击合拍图片进行拍照");
                } else {
                    let QueryOpenCardLocationData = await QueryOpenCardLocation(
                        {
                            uimId: localStorage.getItem("uimId"),
                        }
                    )
                    if (QueryOpenCardLocationData.code != 1) {
                        Dialog.alert({
                            message: "开卡时间过长数据缺失,请重新输入手机号",
                        }).then(() => {
                            this.active = 0
                        })
                    } else {
                        // 上传合拍接口增加工号入参
                        let SignatureUploadData = await SignatureUpload({
                            image: this.TogetherImgsData,
                            workNo: QueryOpenCardLocationData.data.acceptPerson, //工号
                        })
                        if (SignatureUploadData.code != 1) {
                            this.showToast(SignatureUploadData.msg);
                        } else {
                            // 4、拍合照增加缓存记录（入网协议增加缓存记录）
                            let params = this.getOpenCardLocationParams(QueryOpenCardLocationData.data);
                            var AddOpenCardLocationTwo = await AddOpenCardLocation({
                                ...params,
                                openCardLocation: "4", //步骤条进度
                                TogetherUrl: SignatureUploadData.data, //合拍图片地址
                                netSignUrl: QueryOpenCardLocationData.data.netSignUrl, //签名图片地址
                            })
                            if (AddOpenCardLocationTwo.code != 1) {
                                Dialog.alert({
                                    message: "缓存记录失败,请重新进行开卡",
                                }).then(() => {
                                    this.active = 0
                                })
                            } else {
                                this.ifCheckCard = QueryOpenCardLocationData.data.ifCheckCard
                                this.active = 4
                            }
                        }
                    }
                }
            }
            // 第五页 实名页
            else if (this.active == 4) {
                // 获取实名认证地址
                this.goautonym()
            }
        },

        //微信查询返回跳转入网协议操作
        async wxPayQuery() {
            if (localStorage.getItem("payquery") == "1") {
                var QueryOpenCardLocationData = await QueryOpenCardLocation({
                    uimId: localStorage.getItem("uimId"),
                })
                if (QueryOpenCardLocationData.code != 1) {
                    localStorage.setItem("payquery", false)
                    Dialog.alert({
                        message: "开卡时间过长数据缺失,请重新输入手机号",
                    }).then(() => {
                        this.active = 0
                    })
                } else {
                    localStorage.removeItem("payquery")
                    this.ifCheckCard = QueryOpenCardLocationData.data.ifCheckCard
                    this.active = QueryOpenCardLocationData.data.openCardLocation //是否添加小卡版及步骤条赋值
                }
            } else {
                console.log("微信认证失败")
                localStorage.setItem("payquery", false)
            }
        },

        // isReadAll 为 true，代表协议已看完
        handleReadAll(isReadAll) {
            this.isReadAll = isReadAll
        },

        // 处理签名base64
        onSignChange(imgsData) {
            this.imgsData = imgsData
        },

        // 入网协议勾选状态
        onCheckedChange(checked) {
            this.CheckedState = checked
        },

        // 获取实名认证地址
        async goautonym() {
            let QueryOpenCardLocationData = await QueryOpenCardLocation({ uimId: localStorage.getItem("uimId"), })
            if (QueryOpenCardLocationData.code != 1) {
                localStorage.setItem("payquery", false)
                Dialog.alert({
                    message: "开卡时间过长数据缺失,请重新输入手机号",
                }).then(() => {
                    this.active = 0
                })
            } else {
                let GetUrlData = await GetUrl({
                    returnUrl: "/OpenCard",
                    serviceId: QueryOpenCardLocationData.data.serviceId,
                    recordNumber: QueryOpenCardLocationData.data.recordNumber,
                })
                if (GetUrlData.code != 1) {
                    Dialog.alert({
                        message: GetUrlData.msg,
                    }).then(() => {
                        this.active = 0
                    })
                } else {
                    localStorage.setItem("GetToken", GetUrlData.data.token)
                    localStorage.setItem("BizNo", GetUrlData.data.biz_no)
                    this.judge = "RealNameStart" //实名开卡=0需要查询
                    localStorage.setItem("Judge", this.judge) //存储开关
                    window.location.href = GetUrlData.data.url
                }
            }
        },

        // 实名认证查询
        async authentication() {
            if (localStorage.getItem("Judge") == "RealNameStart") {
                console.log("认证成功开始调用")
                // 开始认证查询
                this.active = 4
                // 实名后查询开卡记录
                let QueryOpenCardData = await QueryOpenCardLocation({
                    uimId: localStorage.getItem("uimId"),
                })
                if (QueryOpenCardData.code != 1) {
                    localStorage.setItem("Judge", false) //实名查询禁止
                    Dialog.alert({
                        message: "开卡时间过长数据缺失,请重新输入手机号",
                    }).then(() => {
                        localStorage.setItem("Judge", false)
                        this.active = 0
                    })
                } else {
                    this.ifCheckCard = QueryOpenCardData.data.ifCheckCard //实名认证图片展示赋值
                    try {
                        let bizId = localStorage.getItem("BizNo")
                        // 获取实名认证验证信息接口
                        let GetSimpleOrCardNumData = await GetSimpleOrCardNum({
                            bizId: bizId ? bizId : '',
                            token: localStorage.getItem("GetToken"),
                            uimId: QueryOpenCardData.data.uimId,
                            serviceId: QueryOpenCardData.data.serviceId,
                            workNo: QueryOpenCardData.data.acceptPerson,
                            recordNumber: QueryOpenCardData.data.recordNumber,
                            cityName: QueryOpenCardData.data.cityCode,
                        })

                        if (GetSimpleOrCardNumData.code != 1) {
                            localStorage.setItem("Judge", false) //实名查询禁止
                            this.showToast(GetSimpleOrCardNumData.msg);
                        }
                        // 获取实名认证验证信息接口的否则(接口成功)
                        else {
                            if (GetSimpleOrCardNumData.data.cardNum.success == 0) {
                                if (GetSimpleOrCardNumData.data.simple.success == 0) {
                                    // 一证五户校验接口
                                    let IdentityCardVerifyData = await DoCheckIdentityCodeByWorkNo({
                                        aceptPerson: QueryOpenCardData.data.acceptPerson,
                                        identityCode: GetSimpleOrCardNumData.data.cardNum.confirmIdcardNumber,
                                    })

                                    if (IdentityCardVerifyData.code != 0) {
                                        localStorage.setItem("Judge", false) //实名查询禁止
                                        this.showToast(IdentityCardVerifyData.msg);
                                    } else {
                                        // 提交加密
                                        let QuerySignData = await QuerySign({
                                            serviceId: QueryOpenCardData.data.serviceId,
                                        })
                                        if (QuerySignData.code != 1) {
                                            localStorage.setItem("Judge", false) //实名查询禁止
                                            this.showToast(QuerySignData.msg);
                                        }
                                        // 提交加密接口否则(接口成功)
                                        else {
                                            const CardOutdexData = QueryOpenCardData.data.ifCheckCard != 1
                                                ? GetSimpleOrCardNumData.data.cardNum.back
                                                : QueryOpenCardData.data.TogetherUrl;
                                            QueryOpenCardData.data.rechargeFlag = ""
                                            let params = this.getOpenCardLocationParams(QueryOpenCardData.data, "rechargeAmount");
                                            // 提交
                                            let DosubmitData = await Dosubmits({
                                                ...params,
                                                systemId: "7", //链接开卡
                                                identityKind: "1", //证件类型
                                                cardOutdex: CardOutdexData, //反面(这参数为身份证反面改为合拍的照片路径)
                                                sign: QuerySignData.data.sign, //提交加密的加密串
                                                timestamp: QuerySignData.data.timestamp, //提交加密接口的时间戳
                                                netSignUrl: QueryOpenCardData.data.netSignUrl, //签名图片地址
                                                custPhoto: GetSimpleOrCardNumData.data.simple.image, //人脸
                                                cardIndex: GetSimpleOrCardNumData.data.cardNum.front, //正面
                                                custAddress: GetSimpleOrCardNumData.data.cardNum.address, //地址
                                                customerName: GetSimpleOrCardNumData.data.cardNum.confirmName, //姓名
                                                identityCode: GetSimpleOrCardNumData.data.cardNum.confirmIdcardNumber, //证件号码
                                            })

                                            if (DosubmitData.code == 0) {
                                                // 实名认证查询结束
                                                this.showToast(DosubmitData.msg);
                                                this.active = 0
                                                localStorage.removeItem("paynum")
                                                localStorage.removeItem("BizNo")
                                                localStorage.removeItem("uimId")
                                                localStorage.removeItem("GetToken")
                                                localStorage.removeItem("Judge")
                                            } else if (DosubmitData.code == -2) {
                                                localStorage.setItem("Judge", false) //实名查询禁止
                                                this.active = 0
                                            } else {
                                                localStorage.setItem("Judge", false) //实名查询禁止
                                                this.showToast(DosubmitData.msg);
                                            }
                                        }
                                    }
                                } else {
                                    localStorage.setItem("Judge", false) //实名查询禁止
                                    // 录制视频失败后success不等于0时的判断，并提示
                                    if (GetSimpleOrCardNumData.data.simple.success != 0) {
                                        this.showToast(GetSimpleOrCardNumData.data.simple.message);
                                    } else {
                                        this.showToast("人脸校验失败，请重新继续进行实名");
                                    }
                                }
                            } else {
                                localStorage.setItem("Judge", false) //实名查询禁止
                                // 录入身份证失败后success不等于0时的判断，并提示
                                if (GetSimpleOrCardNumData.data.cardNum.success != 0) {
                                    this.showToast(GetSimpleOrCardNumData.data.cardNum.message);
                                } else {
                                    this.showToast("身份校验失败，请重新继续进行实名");
                                }
                            }
                        }
                    } catch (err) {
                        localStorage.setItem("Judge", false); // 实名查询禁止
                        console.error("获取位置信息失败:", err.message || err);
                    }
                }
            } else {
                console.log("认证失败")
                localStorage.setItem("Judge", false)
            }
        },

        // 获取用户拍摄的照片
        ImgsBase64(message) {
            this.TogetherImgsData = message
        },

        showToast(message, position = "bottom", duration = 1100) {
            Toast({
                message,
                position,
                duration,
            });
        },
    },

    watch: {},

    computed: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
@import "../../assets/css/openCardScss/openCard.scss"
</style>
<style>
.van-checkbox__icon {
    font-size: 30px;
}
</style>